import { DarkTheme } from '@react-navigation/native';
import { MD3DarkTheme, configureFonts } from 'react-native-paper';
import { Colors } from './Colors';

export const PaperTheme = {
  ...MD3DarkTheme,
  fonts: configureFonts({ config: { fontFamily: 'Poppins' } }),
  roundness: 12,
  colors: {
    ...MD3DarkTheme.colors,
    // Purple primary colors
    primary: Colors.purple1, // #DA20D1 - Bright purple for accents
    primaryContainer: Colors.purple1opacity50, // Selected date background
    onPrimaryContainer: Colors.text, // Text on selected dates

    // Yellow secondary colors
    secondary: Colors.yellow0, // #FFD700 - Yellow for secondary actions
    secondaryContainer: Colors.yellow0opacity50,
    onSecondaryContainer: Colors.purple0,

    // Surface colors (modals, backgrounds)
    surface: Colors.purple0, // #200A3E - Dark purple modal background
    surfaceVariant: Colors.purple0opacity85,
    onSurface: Colors.text, // #ECE4F5 - Light text
    onSurfaceVariant: Colors.opacity50,

    // Background
    background: Colors.purple0,
    onBackground: Colors.text,

    // Outline colors
    outline: Colors.opacity20, // Borders
    outlineVariant: Colors.opacity10, // Subtle borders

    // Error colors (keep pink)
    error: Colors.pink0,
    onError: Colors.text,
    errorContainer: Colors.pink0opacity50,
    onErrorContainer: Colors.text,

    // Other colors
    inverseSurface: Colors.text,
    inverseOnSurface: Colors.purple0,
    inversePrimary: Colors.purple1opacity80,
    shadow: Colors.black,
    scrim: Colors.blackOpacity80,
    backdrop: Colors.blackOpacity05,

    // Elevation colors - purple tinted surfaces for modals/cards
    elevation: {
      level0: 'transparent',
      level1: Colors.purpleElevation1, // Lightest elevation
      level2: Colors.purpleElevation2, // Modal background
      level3: Colors.purple0, // Base purple for higher elevation
      level4: Colors.purpleElevation4, // Clock face background
      level5: Colors.purpleElevation5, // Highest elevation
    },
  },
};

export const SunriseTheme = {
  dark: true,
  fonts: {
    regular: {
      fontFamily: 'Poppins',
      fontWeight: 'normal',
    },
    medium: {
      fontFamily: 'Poppins',
      fontWeight: '400',
    },
    light: {
      fontFamily: 'Poppins-Light',
      fontWeight: '300',
    },
    bold: {
      fontFamily: 'Poppins-Bold',
      fontWeight: '700',
    },
    heavy: {
      fontFamily: 'Poppins-Bold',
      fontWeight: '700',
    },
  },
  colors: {
    ...DarkTheme.colors,
    primary: Colors.purple0,
    background: Colors.purple0,
    card: Colors.purple0,
    text: Colors.text,
  },
} as const;
